import { ApiError } from './api';

// Which failed loads get the generic "This didn’t load" + Try again panel
// (M66, D249): the server couldn't be reached, timed out, or broke. A 4xx
// is an answer, not a wait: "List not found", "not an admin", and the page
// keeps its own message and its way back.
export function isRetryableLoadError(error: unknown): boolean {
  if (!(error instanceof ApiError)) return true;
  return error.status === 0 || error.status >= 500;
}
